module.exports = __webpack_public_path__ + "img/Logo_La_Nouvelle_Republique.a73101f2.png";